exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dis-flex{display:flex}.searchCom{height:14.93333vw;background:white}.searchCom-content{position:relative;padding:3.2vw 4.26667vw;width:100%;height:100%}.searchCom-icon{font-size:4.26667vw;flex-grow:0;flex-shrink:0;position:absolute;top:50%;transform:translateY(-50%);left:6.4vw;z-index:2}.searchCom-input{width:100%;height:8.53333vw;line-height:8.53333vw;flex-grow:1;flex-shrink:1;padding-left:7.46667vw;background:#f7f8f9;border:none;outline:none;font-size:3.73333vw}\n", ""]);

// exports
